<div [ngClass]="{'mox-style mox-font mox-ui-page-container': claim.isMox()}">
  <qnect-notification-messages [notifications]="notifications"></qnect-notification-messages>
  <div class="col-12">
    <h5>{{ 'pageConfirmTravelPeriod.heading.title' | translate }}</h5>
    <p>{{ 'pageConfirmTravelPeriod.heading.desc' | translate }}</p>
    <br *ngIf="claim.isMox()" />
  </div>
  <br/>
  <div class="row col-12 main-form">
    <div class="col-lg-9 col-md-12">
      <form>
        <div class="form-group">
          <qnect-ui #TRV_DEPART_DATE [fieldId]="'TRV_DEPART_DATE'" [formGroup]="confirmTravelModel"
                    name="originalDepartureDate"></qnect-ui>
        </div>
        <div class="form-group">
            <qnect-ui #TRV_RETURN_DATE [fieldId]="'TRV_RETURN_DATE'" [formGroup]="confirmTravelModel" 
            [claimsDateValidator]="claim.getClaimTravel().getOriginalDepartureDate()"
                      name="originalReturnDate"></qnect-ui>
        </div>
        <div class="form-group" *ngIf="transactionInfo.shouldShowDateOfLoss()">
                <qnect-ui
                    #TRAVEL_OTH_01_INCIDENT_DATE
                    [fieldId]="'TRAVEL_OTH_01_INCIDENT_DATE'"
                    [formGroup]="confirmTravelModel"
                    [dynamicLabel]="'domesticHelperClaim.dateOfLoss'"
                    name="otherDateOfIncident"
                ></qnect-ui>
        </div>
        
      </form>

    </div>
    <div class="col-lg-3 col-xl-3 col-md-12 hide">
      &nbsp;
    </div>
  </div>
  <div class="submit-bar">
    <abandon-button></abandon-button>
    <button (click)="goToNext()" class="btn btn-primary float-right new-btn">&nbsp;{{ 'claimSection.generalLabels.generalButtonLabels.next' | translate}}&nbsp;<i class="fas fa-arrow-right"></i></button>
  </div>

</div>
